import { render, staticRenderFns } from "./MitigationsRiskScenariosTable.vue?vue&type=template&id=0489cb70&"
import script from "./MitigationsRiskScenariosTable.vue?vue&type=script&lang=js&"
export * from "./MitigationsRiskScenariosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports